import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { getTestIds } from 'seagull/utils/TestIds';
export const GetAnalystAgentPaneTID = (parentTestId)=>getTestIds(parentTestId);
export const isRenderablePart = (part)=>part.type === 'nl_summary' || part.type === 'clarifying_question' || part.type === 'error' || part.type === 'result_table' || part.type === 'chart';
export const readConversationIdFromLocationState = (state)=>{
    if (state == null || typeof state !== 'object') return null;
    const value = state.conversationId;
    return typeof value === 'string' && value.length > 0 ? value : null;
};
export const withConversationId = (state, conversationId)=>{
    const base = state != null && typeof state === 'object' ? state : {};
    return _object_spread_props(_object_spread({}, base), {
        conversationId
    });
};
export const withoutConversationId = (state)=>{
    if (state == null || typeof state !== 'object') return {};
    const { conversationId: _conversationId } = state, rest = _object_without_properties(state, [
        "conversationId"
    ]);
    return rest;
};
export const isRetrievableConversation = (payload)=>{
    var _conversation_turn;
    if (payload == null || typeof payload !== 'object') return false;
    const conversation = payload;
    if (conversation.status !== 'active') return false;
    const state = (_conversation_turn = conversation.turn) === null || _conversation_turn === void 0 ? void 0 : _conversation_turn.state;
    if (state !== 'idle' && state !== 'in_progress') return false;
    return Array.isArray(conversation.messages);
};
export const reconcileServerConversation = (conversation)=>{
    const messages = conversation.messages;
    if (!Array.isArray(messages)) return [];
    return messages.flatMap((message)=>{
        if (message.role === 'user') {
            return typeof message.text === 'string' ? [
                {
                    id: message.id,
                    role: 'user',
                    text: message.text
                }
            ] : [];
        }
        if (message.role === 'assistant') {
            if (!Array.isArray(message.parts)) return [];
            return message.parts.flatMap((part, index)=>isRenderablePart(part) ? [
                    {
                        id: "".concat(message.id, "#").concat(index),
                        role: 'assistant',
                        part
                    }
                ] : []);
        }
        return [];
    });
};
